export default function ImpactDashboardSkeleton() {
  return (
    <div className="impact-skeleton" aria-label="Loading impact dashboard">
      <div className="impact-skeleton__header" />
      <div className="impact-metric-grid">
        {Array.from({ length: 6 }, (_, index) => (
          <div className="impact-skeleton__card" key={index} />
        ))}
      </div>
      <div className="impact-skeleton__chart" />
    </div>
  );
}
